import React from 'react';
import CssFilterConverter from 'css-filter-converter';
import PropTypes from 'prop-types';

const TauriImage = ({
    localImage,
    externalImage,
    alt,
    className,
    onClick,
    color,
    style,
}) => {
    const baseUrl = process.env.PUBLIC_URL || '';

    return (
        <img
            src={localImage ? `${baseUrl}${localImage}` : externalImage}
            alt={alt}
            className={className}
            onClick={onClick}
            style={{
                ...style,
                filter: color
                    ? CssFilterConverter.hexToFilter(color).color
                    : style?.filter || 'none',
            }}
        />
    );
};

TauriImage.propTypes = {
    localImage: PropTypes.string,
    externalImage: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    color: PropTypes.string,
    style: PropTypes.object,
};

TauriImage.defaultProps = {
    localImage: null,
    externalImage: null,
    className: '',
    onClick: null,
    color: null,
    style: {},
};

export default TauriImage;